import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiZap, FiShield, FiBrain, FiHeart } = FiIcons;

const Benefits = () => {
  const benefits = [
    {
      icon: FiClock,
      title: "Fall Asleep in Minutes, Not Hours",
      description: "No more ceiling-staring contests. Our clients report falling asleep 3x faster within the first month.",
      color: "bg-accent-magenta/10 text-accent-magenta"
    },
    {
      icon: FiZap,
      title: "Wake Up Sharp, Stay Sharp",
      description: "Experience 20% boost in cognitive performance when EF strategies meet sleep hygiene. No 3 PM crash, no brain fog.",
      color: "bg-accent-gold/20 text-orange-600"
    },
    {
      icon: FiShield,
      title: "Ditch the Sleep Crutches",
      description: "Stop relying on melatonin, sleep apps, or that extra shot of espresso. Build skills that last a lifetime.",
      color: "bg-accent-lavender/20 text-purple-600"
    },
    {
      icon: FiBrain,
      title: "Think Faster, Stress Less",
      description: "Strengthen working memory and attention during the day. Better focus = less mental exhaustion = easier sleep.",
      color: "bg-accent-purple/20 text-pink-600"
    },
    {
      icon: FiHeart,
      title: "Actually Enjoy Your Evenings",
      description: "Transform bedtime from a battle into something you actually look forward to.",
      color: "bg-accent-yellow/20 text-yellow-600"
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-gradient-to-br from-gray-50 via-white to-accent-light/30">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-5xl font-playfair font-bold text-gray-900 mb-8">
            What Better Sleep Actually Feels Like
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full ${benefit.color} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <SafeIcon icon={benefit.icon} className="w-8 h-8" />
              </div>
              
              <h3 className="text-xl font-playfair font-bold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              
              <p className="text-gray-600 font-raleway leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-accent-magenta text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-accent-magenta/90 transition-all duration-200 shadow-xl hover:shadow-2xl"
          >
            Start Your Transformation
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;